import React from 'react';
import './Bienvenida.css';

const Bienvenida = () => {
    return (
      <div className= "contendor-bienvenida">
        <div className= "mensaje-bienvenida">
            <p>
            En este portal usted podrá realizar la captura de asistencia, su consulta y además el envio de mensajes y registro de reportes            </p>
        </div>
      </div>
    );
  };
  
export default Bienvenida;